import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CompetenciesService } from '../competencies.service';
import { OthersService } from './othersDataService';
import { OthersWidgetModel } from 'src/app/Models/OthersWidgetModel';
import { TemplatesService } from '../../templates/templates.service';


@Component({
  selector: 'app-others',
  templateUrl: './others.component.html',
  styleUrls: ['./others.component.css']
})
export class OthersComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    private service: CompetenciesService,
    private _service: TemplatesService,
    private othersService: OthersService,
    private router: Router,) { }

  competencyname: string;
  competencyId: number;
  subCompetencyId: any;
  otherCountData: othercounttype;
  subCompetencyName: string;
  artifactory: any;

  ngOnInit() {
    this._service.getAllTemplateCategories().subscribe(res => {
      this.artifactory = res.data.items
    })

    this.service.profileStatus$.subscribe(x => {
      this.competencyId = x
      if (this.competencyId == null) {
        this.competencyId = Number(sessionStorage.getItem("compId"))
      }
    }
    );
    this.service.competencyName$.subscribe(x => {
      this.competencyname = x
      if (this.competencyname == null || this.competencyname == "") {
        this.competencyname = sessionStorage.getItem("compTitle")
      }
    }
    )
    this.othersService.id$.subscribe(id => {
      this.subCompetencyId = id;
      if (this.subCompetencyId == null || this.subCompetencyId == 0) {
        this.subCompetencyId = Number(sessionStorage.getItem("SubcompId"))
      }
    }
    );
    this.othersService.name$.subscribe(name => {
      this.subCompetencyName = name;
      if (this.subCompetencyName == null || this.subCompetencyName == "") {
        this.subCompetencyName = sessionStorage.getItem("SubcompTitle")
      }
    }
    );
    //this.handleIdChange();
  }

  navigateToArtifactory(category: string) {
    if (category) {
      this.router.navigate(["/Home/Artifactory", category], {
        queryParams: {},
      });
    }
  }

  handleIdChange() {
    this.service.GetOthersCount(this.competencyId, this.subCompetencyId).subscribe(value => {
      this.otherCountData = value
    })
  }
  othersWidgetData: OthersWidgetModel;

  backToToolGrid1(name: string, id: string) {

    const sendData = {
      value: id,
      name: name,
    }

    this.othersService.updatetooltypeId(sendData);
    sessionStorage.setItem("TooltypeId", sendData.value);
    sessionStorage.setItem("ToolTypename", sendData.name);
    this.subCompetencyName = this.subCompetencyName.replace(/\//g, '');
    this.subCompetencyName = this.subCompetencyName.split(' ').join('');

    this.router.navigate([`Home/CMF Portal/${this.competencyname}/${this.subCompetencyName}/Others/${sendData.name}`]);
  }
}
export interface othercounttype {
  toolsCount: number,
  templatesCount: number,
  acceleratorsCount: number,
  kmsDocumentsCount: number
}
